import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { AppSettingsService } from '@capital-access/common/settings';
import {
  Breakpoint,
  FireflyCardsModule,
  FireflyInnerErrorModule,
  MobileInnerErrorOptions
} from '@capital-access/firefly/components';
import { PENDO_SCOPE } from './constant';
import { CardContentAutoHeightDirective } from './directives/card-content-auto-height.directive';
import { PendoSettings } from './models/pendo-settings';

@Component({
  selector: 'ca-pendo-portal-page',
  standalone: true,
  imports: [
    FireflyCardsModule,
    FireflyInnerErrorModule,
    CommonLocalizationModule,
    CommonModule,
    CardContentAutoHeightDirective
  ],
  template: `
    <div [caLocalizationScope]="localizationScope" class="ps-0 ps-md-7 h-100">
      <f-large-card [title]="'feedbackPortal' | caLocalize" data-automation-id="feedback-portal-card">
        @if(!isMobile()) {
        <iframe [src]="portalUrl" caCardContentAutoHeight class="w-100" allowfullscreen frameborder="0"></iframe>
        }@else{
        <f-mobile-inner-error [errorOption]="mobileInnerErrorOptions.TabletView"></f-mobile-inner-error>
        }
      </f-large-card>
    </div>
  `
})
export class PendoPortalPageComponent {
  readonly localizationScope = PENDO_SCOPE;
  readonly mobileInnerErrorOptions = MobileInnerErrorOptions;

  private sanitizer = inject(DomSanitizer);
  private settingsService = inject(AppSettingsService);
  private settings = this.settingsService.getSettings<PendoSettings>();

  isMobile = signal(window.innerWidth < Breakpoint.Md);

  portalUrl =
    this.settings.pendo?.apiKey && this.settings.pendo?.portalId
      ? this.sanitizer.bypassSecurityTrustResourceUrl(
          `https://portal.pendo.io/p/${this.settings.pendo.apiKey}/${this.settings.pendo.portalId}?container=embed`
        )
      : null;
}
